export enum BillingRecurringTypes {
    Yearly = 2,
    Monthly = 1,

}

export interface IUpgradableProductsResponse {
    FromProductID: number;
    FromProductName: string;
    FromBillingCycle: BillingRecurringTypes;
    HasYard: boolean;
    ProductID: number;
    Name: string;
    Price: number;
    BillingCycle: BillingRecurringTypes;
}

export class UpgradableProductsResponse implements IUpgradableProductsResponse {
    FromProductID: number;
    FromProductName: string;
    FromBillingCycle: BillingRecurringTypes;
    HasYard: boolean;
    ProductID: number;
    Name: string;
    Price: number;
    BillingCycle: BillingRecurringTypes;
}

export class UpgradableProductsResponseArray extends Array<UpgradableProductsResponse> {

    constructor(...items: UpgradableProductsResponse[]) {
        super(...items);
        Object.setPrototypeOf(this, UpgradableProductsResponseArray.prototype);
    }

}